__turbopack_context__.v({
  "eliza": "npGOeW_eliza",
  "hero": "npGOeW_hero",
  "heroContent": "npGOeW_heroContent",
  "image": "npGOeW_image",
  "sunweb": "npGOeW_sunweb",
});
